import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const container = css``;

/* The width and side gutters come from SectionContainer, as on department pages. */
export const main = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.sm});
  padding: var(${spacing.lg}) 0 var(${spacing.xxl});
`;

export const header = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.sm});
`;

export const title = css`
  margin: 0;
  font-family: var(${typography.heading.fontFamily});
  font-weight: var(${typography.heading.fontWeight});
  font-size: var(${typography.heading.sizes.lg.fontSize});
  line-height: var(${typography.heading.sizes.lg.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
  color: var(${colors.content.default});
`;

export const intro = css`
  margin: 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.default});
`;

/* The page's gap sets the space above the tabs; the content sits further below them. */
export const content = css`
  padding-top: var(${spacing.lg});
`;

/* The design separates each category's row, and the grid from its pagination, with a divider and a wider gap than anything inside them. */
export const stack = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.xxl});
`;

export const divider = css`
  width: 100%;
  margin: 0;
  border: 0;
  border-top: 1px solid var(${colors.stroke.default});
`;
